import { httpRequest } from "@/lib";
import { useMutation, useQueryClient } from "@tanstack/react-query";

type Props = {
  budgetId: string;
};

const requestBudgetsPDF = async ({ budgetId }: Props) => {
  const response = await httpRequest.get(`/budgets/${budgetId}/export-pdf`, {
    responseType: "blob",
  });
  return response.data;
};

export function useRequestBudgetsPDFMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: requestBudgetsPDF,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["budgets-request-pdf"] });
    },
  });
}
